import {Hero} from "../../components/Hero";
import { Careers } from "./Careers";
import { HowItWorks } from "./HowItWorks";
import { Internship } from "./Internship";
import { Services } from "./Services";
import { Testimonials } from "./Testimonials";
import { Training } from "./Training";

export default function Home() {
return (

<div>
<Hero />
<Services />
<Training />
<Internship />
<HowItWorks />
<Testimonials />
<Careers />
</div>

);

}